import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getDefaultMobileWidth } from '../../custom-hooks/screen-detector';


const MTextCon = styled.div`
  display: ${props => (props.isInlineText ? 'inline-block' : 'block')};
  line-height: 1.35;
  font-family: ${props => props.$fontFamily} !important;
  font-size: ${props => props.$fontSize}px;
  color: ${props => props.$color};
  font-weight: ${props => props.$fontWeight};
  font-style: ${props => props.$fontStyle};
  text-decoration: ${props => props.$textDecoration};
  text-align: ${props => props.$textAlignment};
  padding: ${props => props.$padding};
  margin: ${props => props.$margin};
  cursor: ${props => props.$cursor};
  ${props => (props.$width ? `width: ${props.$width}` : null)};

  @media (max-width: ${getDefaultMobileWidth()}px) {
    font-size: ${props => props.$mobileFontSize}px;
  }

  ${props => (props.lineHeight ? `line-height: ${props.lineHeight}` : null)};
  ${props =>
    props.paddingRight ? `padding-right: ${props.paddingRight}` : null};
  ${props => (props.marginRight ? `margin-right: ${props.marginRight}` : null)};
  ${props => (props.marginTop ? `margin-top: ${props.marginTop}` : null)};

  white-space: pre-wrap;
`;

export const MText = props => {
  const {
    text,
    fontSize,
    mobileFontSize,
    color,
    fontStyle,
    fontWeight,
    textDecoration,
    fontFamily = 'inherit',
    textAlignment,
    margin,
    padding,
    width,
    cursor = 'auto',
    lineHeight,
    isInlineText,
    paddingRight,
    marginRight,
    marginTop,
    children,
    className = '',
    onTextClick,
  } = props;
  return (
    <MTextCon
      $fontSize={fontSize}
      $mobileFontSize={mobileFontSize}
      $color={color}
      $fontStyle={fontStyle}
      $fontWeight={fontWeight}
      $textDecoration={textDecoration}
      $fontFamily={fontFamily}
      $textAlignment={textAlignment}
      $margin={margin}
      $padding={padding}
      $width={width}
      $cursor={cursor}
      lineHeight={lineHeight}
      isInlineText={isInlineText}
      paddingRight={paddingRight}
      marginRight={marginRight}
      marginTop={marginTop}
      className={`${className} mr-text`}
      onClick={onTextClick}
    >
      {text || children}
    </MTextCon>
  );
};

MText.propTypes = {
  children: PropTypes.node,
  fontSize: PropTypes.string,
  mobileFontSize: PropTypes.string,
  color: PropTypes.string,
  fontStyle: PropTypes.string,
  fontWeight: PropTypes.string,
  textDecoration: PropTypes.string,
  fontFamily: PropTypes.string,
  textAlignment: PropTypes.string,
  margin: PropTypes.string,
  padding: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  isInlineText: PropTypes.bool,
  lineHeight: PropTypes.string,
  onTextClick: PropTypes.func,
  cursor: PropTypes.string,
  // DEPRECATED: below props are going to deprecate with restructuring
  text: PropTypes.string,
  paddingRight: PropTypes.string,
  marginRight: PropTypes.string,
  marginTop: PropTypes.string,
};
